import React, { FC } from 'react';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import { productionBatchStatistics } from '@reducers/statistics';
import { getNCFileById } from '@reducers/manufacture';
import { close as clearTools, getTools } from '@reducers/clampingTools';
import { connect } from 'react-redux';
import { useBatchDetails } from '@v2/pages/common/hooks/useBatchDetails';
import { updateHeaderConfig } from '@reducers/details';
import { OperationSearchItem, ProductionBatchStatistics } from '@interfaces/search';
import { ReducerEntityWithLoadingState } from '@v2/pages/common/interfaces';
import { SingleJobOrList } from '@v2/pages/machines/modules/now/components/Job/components/SingleJobOrList';

interface BatchDetailsJobProps {
  batch: ReducerEntityWithLoadingState<ProductionBatchStatistics | null>;
  jobId: number | null;
  jobs: ReducerEntityWithLoadingState<OperationSearchItem[]>;
  batchLoadedTime: string;
}

const BatchDetailsJobComponent: FC<BatchDetailsJobProps> = ({
  productionBatchStatistics,
  getNCFileById,
  getTools,
  clearTools,
  updateHeaderConfig,
  jobs,
  batch,
  jobId,
}) => {
  const title = useTitle();

  useBatchDetails({
    clearTools,
    getNCFileById,
    getTools,
    productionBatchStatistics,
    updateHeaderConfig,
  });

  return (
    <DetailsPageWrapper title={title.job}>
        <SingleJobOrList jobs={jobs.data} jobId={jobId} loading={!batch.wasLoaded} shouldTakeFromBatch />
    </DetailsPageWrapper>
  );
};

const BatchDetailsJobs = connect(({ batch: { batch }, details: { jobId, jobs } }) => ({ batch, jobId, jobs }), {
  getNCFileById,
  productionBatchStatistics,
  getTools,
  clearTools,
  updateHeaderConfig,
})(BatchDetailsJobComponent);

export { BatchDetailsJobs };
